import React from 'react';

export default function MobileProductFeedback({ error, message, loading, onRetry }) {
  return (
    <>
      {loading && (
        <p className='mp-loading' role='status'>
          Завантаження…
        </p>
      )}
      {error && (
        <div className='mp-feedback mp-feedback-error' role='alert'>
          {error}
          {onRetry && (
            <button type='button' className='btn btn-outline-danger' onClick={onRetry}>
              Повторити
            </button>
          )}
        </div>
      )}
      {message && (
        <div className='mp-feedback mp-feedback-success' role='status'>
          {message}
        </div>
      )}
    </>
  );
}
